export const HISTORY_STATUS = {
  "-2": "Chưa ấn chơi",
  "-1": "Đang mưa vé",
  0: "Đã giật vé, chưa cào",
  5: "Đã cào xong chưa nhấn xác nhận",
  6: "Đã ấn xác nhận",
  7: "User đã nhận đc phần thưởng",
};
